import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { Calendar as CalendarIcon } from "lucide-react";

/**
 * Shadcn calendar popover styled to the TCM brand. Returns ISO yyyy-mm-dd via onChange.
 * Backwards-compatible with native <input type="date"> usages — same onChange signature.
 */
export function TcmDatePicker({ value, onChange, placeholder = "Select date", testId, min, max, disabled }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(value + "T00:00:00") : undefined;
  const label = date
    ? date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
    : placeholder;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          data-testid={testId}
          className="tcm-input flex items-center gap-2 text-left w-full disabled:opacity-50">
          <CalendarIcon size={14} className="opacity-60 shrink-0" />
          <span className={date ? "" : "opacity-50"}>{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 w-auto bg-[color:var(--tcm-cream)] border border-[color:var(--tcm-navy)]">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => {
            if (!d) return onChange?.("");
            const iso = d.toISOString().slice(0, 10);
            onChange?.(iso);
            setOpen(false);
          }}
          disabled={(d) => {
            if (min && d < new Date(min + "T00:00:00")) return true;
            if (max && d > new Date(max + "T23:59:59")) return true;
            return false;
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export default TcmDatePicker;
